import $ from 'jquery'
import { registerComponent } from '../app'
import Cart from '../services/Cart'
import { money } from '../helpers/format'
import { OPEN_CART, VARIANT_CHANGE } from '../events'

const ProductAtc = (scope, el) => {
    const props = {
        productId: el.getAttribute('data-product-id'),
        productInfo: JSON.parse(
            document.getElementById('product-data-' + el.getAttribute('data-product-id')).innerHTML
        ),
        loadingClass: 'loading',
        emitEvents: el.hasAttribute('data-emit-events'),
        preventDefault: el.hasAttribute('data-prevent-default')
    }

    const els = {
        $form: $(el.querySelector('form') || el),
        $options: $(el).find('[data-option-select]'),
        $price: $(el).find('[data-price]'),
        $compareAtPrice: $(el).find('[data-compare-at-price]'),
        $soldOut: $(el).find('[data-sold-out]'),
        $atcButton: $(el).find('[data-atc]'),
        $showOnSubscription: $(el).find('[data-show-on-subscription]'),
        $hideOnSubscription: $(el).find('[data-hide-on-subscription]'),
        $showOnSoldOut: $(el).find('[data-show-on-sold-out]'),
        $hideOnSoldOut: $(el).find('[data-hide-on-sold-out]'),
        $showOnOption: $(el).find('[data-show-on-option]')
    }

    const state = {
        values: [],
        variant: null
    }

    function getVariant(optionOverridesArray) {
        if (props.productInfo.variants.length == 1) {
            return props.productInfo.variants[0]
        }

        let formValues = getFormValues()
        let defaultOptions = formValues.filter(item => item.name.indexOf('option_select') > -1)

        defaultOptions.sort(function(a, b) {
            return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })

        let options = []

        if (optionOverridesArray && optionOverridesArray.length) {
            defaultOptions.map((item, index) => {
                let option = item
                optionOverridesArray.map(overrideOption => {
                    if (overrideOption.name == item.name) {
                        option = overrideOption
                    }
                })
                options.push(option)
            })
        } else {
            options = defaultOptions
        }

        let title = ''

        options.map((item, index) => {
            title += (index > 0 ? ' / ' : '') + item.value.toString()
        })

        return props.productInfo.variants.filter(variant => variant.title == title)[0]
    }

    function getFormValues() {
        return els.$form.serializeArray()
    }

    function updatePrice(el) {
        if (!el.hasAttribute('data-option-name')) {
            $(el).text(money(state.variant.price))
            return
        }

        const name = el.getAttribute('data-option-name')
        const value = el.getAttribute('data-option-value')

        const variant = getVariant([{ name, value }])

        $(el).text(money(variant.price / value))
    }

    function updateState() {
        const activeVariant = getVariant()

        if (state.variant != activeVariant && props.emitEvents) {
            scope.emit(VARIANT_CHANGE, activeVariant)
        }

        state.values = els.$form.serializeArray()
        state.variant = activeVariant

        els.$showOnOption.each(function() {
            const name = this.getAttribute('data-option-name')
            const value = this.getAttribute('data-option-value')

            let match = false

            state.values.map(item => {
                if (item.name == name && item.value == value) match = true
            })
            match ? $(this).show() : $(this).hide()
        })

        // if variant is sold out

        if (!state.variant.available) {
            els.$atcButton.prop('disabled', true)
            els.$price.hide()
            els.$compareAtPrice.hide()
            els.$soldOut.show()
            els.$showOnSoldOut.show()
            els.$hideOnSoldOut.hide()
        } else {
            els.$atcButton.prop('disabled', false)
            els.$price.show()
            els.$compareAtPrice.show()
            els.$soldOut.hide()
            els.$showOnSoldOut.hide()
            els.$hideOnSoldOut.show()
        }

        // update price

        els.$price.each(function() {
            updatePrice(this)
        })

        // update subscription

        if (getValue('order_type') == 'subscription') {
            els.$showOnSubscription.show()
            els.$hideOnSubscription.hide()
        } else {
            els.$showOnSubscription.hide()
            els.$hideOnSubscription.show()
        }
    }

    function getValue(name) {
        let filtered = state.values.filter(item => item.name == name)[0]
        return filtered ? filtered.value : null
    }

    function isSubscription() {
        return getValue('order_type') == 'subscription'
    }

    // events

    els.$form.change(() => updateState())

    els.$atcButton.click(e => {
        props.preventDefault && e.preventDefault()

        setTimeout(() => {
            if (!state.variant) return

            el.classList.add(props.loadingClass)

            let data = {
                id: isSubscription() ? state.variant.subscriptionVariantId : state.variant.id,
                quantity: getValue('quantity'),
                properties: {
                    _is_subscription: isSubscription(),
                    _product_title: props.productInfo.title,
                    _variant_title: state.variant.display_title
                        ? state.variant.display_title
                        : state.variant.title,
                    _compare_at_price: state.variant.compare_at_price
                        ? state.variant.compare_at_price
                        : props.productInfo.compare_at_price,
                    _image: state.variant.image ? state.variant.image : props.productInfo.image
                }
            }

            if (isSubscription()) {
                data.properties._shipping_interval_frequency = getValue('subscription_interval')
                data.properties._shipping_interval_unit_type = getValue(
                    'subscription_interval_type'
                )
                data.properties._subscription_id = getValue('state.variant.subscriptionId')
                data.properties._subscription_discount = getValue('state.variant.subscriptionId')
            }

            Cart.addItem(data).then(() => {
                el.classList.remove(props.loadingClass)

                // dispatch events

                scope.emit(OPEN_CART)

                const event = new CustomEvent('addedToCart', {
                    bubbles: true,
                    cancelable: true,
                    detail: data
                })

                el.dispatchEvent(event)
            })
        }, 500)
    })

    // start

    updateState()
}

registerComponent('product-atc', ProductAtc)
